<template>
    <div v-loading="listContentLoading">      
      <el-input
        class="search-el"
        size="mini"
        v-model="query.title"
        clearable
        placeholder="请输入合集标题"
      ></el-input>      
      <el-button type="primary" size="mini" @click="getCollectionList()"> 查询</el-button>
      <el-button type="primary" size="mini" @click="toCreate()"> 新建合集</el-button>

      <el-row>
        <el-table
          v-loading="loading"
          :data="list"
          border
          size="mini"
          :stripe="true"
          style="width: 100%; margin: 20px 0;"
        >
          <el-table-column
            prop="id"
            label="ID"
            align="center"
            min-width="3%"
          ></el-table-column>
          <el-table-column label="合集标题" align="center" min-width="15%">
            <template slot-scope="{ row }">
              <el-button type="text" size="small" @click="toEdit(row.id)">
                <div>{{ row.title }}</div>
              </el-button>
            </template>
          </el-table-column>

          <el-table-column label="合集地址" align="center" min-width="5%">
            <template slot-scope="{ row }">
              <el-button
                  type="primary"
                  size="mini"
                  @click="viewURL(row.link)"
              >
                查看
              </el-button>
            </template>
          </el-table-column>

          <el-table-column label="合集商品" align="center" min-width="5%">
            <template slot-scope="{ row }">
<!--              <el-button
                  type="primary"
                  size="mini"
                  @click="toChannelItem(row.id)"
              >
                编辑
              </el-button>-->
              <el-button type="primary" size="small" @click="gotoProductList(row.id)">编辑</el-button>
            </template>

          </el-table-column>

          <el-table-column
            prop="link_click_nums"
            label="链接点击次数"
            align="center"
            min-width="5%"
          ></el-table-column>

  
<!--          <el-table-column label="操作" align="center" min-width="14%">
            <template slot-scope="{ row }">
              &lt;!&ndash; <el-button type="danger" size="mini" @click="deleteChannel(row.id)">
                删除
              </el-button> &ndash;&gt;
  
              <el-button
                size="mini"
                @click="toChannelItemData(row.id)"
              >
                数据
              </el-button>

              <el-button
                size="mini"
                @click="toChannelItem(row.id)"
              >
                推广位
              </el-button>
            </template>
          </el-table-column>-->
        </el-table>
      </el-row>
      <el-row>
        <div class="block">
          <el-pagination
            background
            @current-change="getCollectionList"
            :current-page.sync="query.page"
            :page-size="query.limit"
            layout="total, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </el-row>

      <!-- 二维码弹窗 -->
      <el-dialog title="电商合集地址" :visible.sync="dialogVisible2" width="50%">
        <el-input
            v-model="collection_url"
            style="width: 66%; margin-left: 256 /2; position: relative; left: 10%;"
        ></el-input>
        <div
            id="qrcode"
            style="margin-left: 256 /2; position: relative; left: 10%;"
        ></div>
        <span slot="footer" class="dialog-footer">
        <el-button type="text" @click="copy(collection_url)">复制</el-button>
        <el-button
            type="primary"
            @click="
            dialogVisible2 = false;
            collection_url = '';
          "
        >确 定</el-button
        >
      </span>
      </el-dialog>

      <el-dialog title="合集" :visible.sync="dialogEdit" v-loading="loadingEdit" width="35%" @close="cancel">
        <el-form :model="collectionInfo" ref="collectionInfo">
          <el-form-item  label="请输入合集标题：" :required="true">
            <el-input maxlength="20" minlength="1" size="small" v-model="collectionInfo.title" clearable />
          </el-form-item>

          <el-form-item label="页面背景图">
            <el-col class="add_flex" :span="5">
              <activityCustomUpload :formName="'background_img_url'" :formValue="collectionInfo.background_img_url" @uploadSuccess="uploadSuccess"></activityCustomUpload>
            </el-col>
          </el-form-item>

          <el-form-item  label="页面背景色：" >
<!--            <el-input size="small" type="color" auto-complete="true" v-model="collectionInfo.background_color_value" style="width: 200px;" clearable />-->
            <el-color-picker v-model="collectionInfo.background_color_value"></el-color-picker>
          </el-form-item>


        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancel()">取 消</el-button>
          <el-button type="primary" @click="saveCollection()">确 定</el-button>
        </div>
      </el-dialog>

    </div>
  </template>
  
  <script>
  import {
    deleteChannel,
  } from "@/api/cChannel";

  import {
    getCollectionList,createCollection,getCollectionInfo
  } from "@/api/productCollection";
  import activityCustomUpload from "@/components/activityCustomUpload.vue";
  import { formatDateTime, qrCode, copyData, getCategoryList, getTeacherList } from "@/api/common";
  
  export default {
    components: { activityCustomUpload },
    data: function () {
      return {
        collection_url: "",
        dialogVisible2: false,
        dialogVisible: false,
        dialogEdit: false,
        list: [],
        loading: false,
        loadingEdit: false,
        total: 0,
        query: {
          page: 1,
          limit: 20,
          title: "",
        },
        collectionInfo: {
          id: 0,
          title: '',
          background_img_url: "",
          background_color_value: "",
        },
        listContentLoading: false,
      };
    },
    created: function () {
      this.getCollectionList();
    },
    methods: {
      gotoProductList(id) {
        this.$router.push({
          path: "/mall/collection/productList",
          query: {
            id: id,
            admin_id: this.$route.query.admin_id,
            admin_name: this.$route.query.admin_name
          }
        });
      },

      viewURL(link) {
        this.dialogVisible2 = true;
        this.$nextTick(function () {
          document.getElementById("qrcode").innerHTML = "";
          this.collection_url = link;
          let qrcode = qrCode(link, 300, 300);
        });



      },

      copy(url) {
        copyData(url);
        this.$message({
          message: "复制成功",
          type: "success",
        });
      },
      toCreate() {
        this.dialogEdit = true;
      },
      cancel(){
        this.dialogEdit = false;
        this.collectionInfo = {
          id: 0,
          title: '',
          background_img_url: "",
          background_color_value: "",
        }
      },
      uploadSuccess(value){
        this.$set(this.collectionInfo, value.formName, value.fileUrl)
      },
      saveCollection(){
        if(this.collectionInfo.title.length < 1 || this.collectionInfo.title.length > 20){
          this.$message({
            message: '合集名称需为1~20个字符',
            type: 'warning'
          });
          return false;
        }
        this.dialogEdit = false;
        createCollection(this.collectionInfo)
            .then((response) => {
              if (response.code == 1) {
                this.$message.success(response.message);
                this.cancel();
                this.getCollectionList();
              }
            });
      },

      toEdit(id = 0) {
        this.dialogEdit = true;
        this.loadingEdit = true;
        getCollectionInfo({id: id})
            .then((response) => {
              if (response.code == 1) {
                this.collectionInfo = response.data;
                this.loadingEdit = false;
              }
            });
      },

      getCollectionList() {
        this.loading = true;
        getCollectionList(this.query).then((response) => {
          this.list = response.data.list;
          this.total = response.data.total;
          this.loading = false;
        });
      },
  
      deleteChannel(id) {
        this.$confirm("此操作将删除该对象, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
            deleteChannel({
            id: id,
          }).then((response) => {
            if (response.status == 2000) {
              this.getCollectionList();
              this.$message({
                showClose: true,
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                showClose: true,
                message: response.message,
                type: "error",
              });
            }
          });
        });
      },
    },
    mounted() {},
  };
  </script>
  